<template>
    <div>
        <div class="badgesOrder">
            <div class="badgeOrder" v-for="(badge, index) in badges">
                <div class="row">
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label :for="'badges[' + index + '][firstname]'">
                                <slot name="firstname-label"></slot>
                            </label>
                            <input type="text" :name="'badges[' + index + '][firstname]'" v-model="badge.firstname"  @keydown.enter.prevent>
                        </div>
                    </div>

                    <div class="col-lg-3">
                        <div class="form-group">
                            <label :for="'badges[' + index + '][lastname]'">
                                <slot name="lastname-label"></slot>
                            </label>
                            <input type="text" :name="'badges[' + index + '][lastname]'" v-model="badge.lastname"  @keydown.enter.prevent>
                        </div>
                    </div>

                    <div class="col-lg-3">
                        <div class="form-group">
                            <label :for="'badges[' + index + '][position]'">
                                <slot name="position-label"></slot>
                            </label>
                            <input type="text" :name="'badges[' + index + '][position]'" v-model="badge.position"  @keydown.enter.prevent>
                        </div>
                    </div>

                    <div class="col-lg-2 badgeOrder__actions">
                        <button type="button" class="btn-medium-grey badgeOrder__delete" @click="deleteBadge(index)">
                            <slot name="delete-label"></slot>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <button type="button" class="btn-blue" @click="addBadge">
                <slot name="add-label"></slot>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            oldBadges: {
                type: Array,
                firstname: String,
                lastname: String,
                position: String,
                default: () => [
                    {
                        firstname: '',
                        lastname: '',
                        position: ''
                    }
                ]
            }
        },
        data() {
            return {
                badges: this.oldBadges
            }
        },
        methods: {
            addBadge() {
                this.badges.push({
                    firstname: '',
                    lastname: '',
                    position: ''
                });
            },
            deleteBadge(badgeIndex) {
                this.badges.splice(badgeIndex, 1);
                if (this.badges.length === 0) {
                    this.addBadge();
                }
            }
        }
    }
</script>
